import { useState } from "react";
import { useAuth } from "../contexts/AuthContext";

function formatApiError(detail) {
  if (detail == null) return "E-mail ou senha inválidos.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default function LoginPage({ onBack }) {
  const { login } = useAuth();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email.trim(), password);
    } catch (err) {
      console.error("[DALFA] Login error:", err);
      if (err.response) {
        const status = err.response.status;
        const detail = err.response.data?.detail;
        console.error("[DALFA] Response status:", status, "detail:", detail);
        if (status === 429) {
          setError("Muitas tentativas. Aguarde 15 minutos e tente novamente.");
        } else if (status === 403) {
          setError(detail || "Acesso não autorizado.");
        } else {
          setError(detail || "E-mail ou senha inválidos.");
        }
      } else if (err.request) {
        console.error("[DALFA] No response received:", err.message);
        setError("Sem resposta do servidor. Verifique a sua internet ou tente novamente.");
      } else {
        console.error("[DALFA] Request setup error:", err.message);
        setError("Erro: " + (err.message || "Tente novamente."));
      }
    } finally {
      setLoading(false);
    }
  };

  const handlePasswordChange = (e) => {
    // Remove any leading/trailing whitespace or newlines from paste
    const val = e.target.value.replace(/[\n\r]/g, "");
    setPassword(val);
  };

  const handlePasswordPaste = (e) => {
    e.preventDefault();
    const pasted = (e.clipboardData || window.clipboardData).getData("text");
    // Clean pasted text: remove whitespace, newlines, zero-width chars
    const cleaned = pasted.replace(/[\s\u200B\u200C\u200D\uFEFF]/g, "").trim();
    setPassword(cleaned);
  };

  return (
    <div className="dalfa-auth-page" data-testid="login-page">
      <div className="dalfa-auth-card">
        <button className="dalfa-back-btn" onClick={onBack} data-testid="login-back-btn">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M19 12H5M12 19l-7-7 7-7"/></svg>
        </button>

        <img
          src="https://customer-assets-7cd3h4nn.emergentagent.net/job_668c4879-79ca-423e-b1cc-dd12ca40e1a2/artifacts/j1j0s0hk_1937.png"
          alt="DALPHA PRIME 2.0"
          className="dalfa-auth-logo-img"
        />
        <p className="dalfa-auth-subtitle">Faça login na sua conta</p>

        <form onSubmit={handleSubmit} className="dalfa-auth-form" data-testid="login-form">
          {error && <div className="dalfa-auth-error" data-testid="login-error">{error}</div>}
          <div className="dalfa-auth-field">
            <label htmlFor="email">E-mail</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="seu@email.com"
              required
              autoFocus
              autoComplete="email"
              data-testid="login-email-input"
            />
          </div>
          <div className="dalfa-auth-field">
            <label htmlFor="password">Senha</label>
            <div className="dalfa-password-wrapper">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                value={password}
                onChange={handlePasswordChange}
                onPaste={handlePasswordPaste}
                placeholder="Digite a sua senha"
                required
                autoComplete="current-password"
                data-testid="login-password-input"
              />
              <button
                type="button"
                className="dalfa-password-toggle"
                onClick={() => setShowPassword(!showPassword)}
                tabIndex={-1}
                data-testid="login-password-toggle"
                aria-label={showPassword ? "Esconder senha" : "Mostrar senha"}
              >
                {showPassword ? (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M17.94 17.94A10.07 10.07 0 0112 20c-7 0-11-8-11-8a18.45 18.45 0 015.06-5.94"/>
                    <path d="M9.9 4.24A9.12 9.12 0 0112 4c7 0 11 8 11 8a18.5 18.5 0 01-2.16 3.19"/>
                    <line x1="1" y1="1" x2="23" y2="23"/>
                  </svg>
                ) : (
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/>
                    <circle cx="12" cy="12" r="3"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
          <button
            type="submit"
            className="dalfa-auth-submit"
            disabled={loading}
            data-testid="login-submit-btn"
          >
            {loading ? "A entrar..." : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
